"use strict";
const EventEmitter = require('events').EventEmitter;
const extend  = require('util')._extend;

class SignalBase extends EventEmitter {
	constructor(opts) {
		super();

        this.canReceive = false;

        this.rx = this.rx.bind(this);
        this.tx = this.tx.bind(this);
        this.cmd = this.cmd.bind(this);

		this._opts = opts;
	}

	rx() {
		throw new Error('receiving_unsupported');
	}
	tx() {
		throw new Error('sending_unsupported');
	}
	cmd() {
		throw new Error('commands_unsupported');
	}

	txRaw(data, repetitions, opts) {
		let transmit = extend({data : data}, opts || this._opts);
        if(repetitions) transmit.repetitions = repetitions;
        transmit.repetitions = transmit.repetitions || 20;
        this.emit('tx', transmit);
        return data;

	}

    unregister(device) {
        this.emit('unregistred', device);
        if(this.canReceive) device.removeListener('rx', this.rx);
        this.removeListener('tx', device.tx);
        return this;
    }

    register(device) {
        if(!device.tx || !device.on) throw new Error('Device does not support events');
        if(this.canReceive) device.on('rx', this.rx);
        this.on('tx', device.tx);
        return this;
    }
}

module.exports = SignalBase;